import * as device from "@otto-ec/global-device";
import type { DeviceType } from "@otto-ec/global-device/dist/types/lib/type";
import type { Breakpoint } from "@otto-ec/global-breakpoint";

export interface GlobalDevice {
  Hybrid: typeof device.Hybrid;
  Orientation: typeof device.Orientation;
  isTouchable: boolean;
  os: string;
  screen: typeof device.screen;
  browser: string;
  orientation: device.Orientation;
  hybrid: device.Hybrid;
  type: DeviceType;
  breakpoint: Breakpoint;
}

// Export Device functionality to global namespace.
window.o_global = window.o_global || {};

window.o_global.device = {
  Hybrid: device.Hybrid,
  Orientation: device.Orientation,
  isTouchable: device.isTouchable(),
  os: device.os(),
  screen: device.screen,
  browser: device.browser(),
  orientation: device.orientation(),
  hybrid: device.hybrid(),
  type: device.type(),
  breakpoint: window.o_global.breakpoint,
};
